import React, { useState, useEffect } from "react";
import classes from "./MobileHeader.module.scss";
import ButtonComponent from "../../ButtonComponent";
import { COLORS } from "../../../lib/colors";
import SettingsIcon from "@mui/icons-material/Settings";
import HelpIcon from "@mui/icons-material/Help";
import logo from "../../../assets/images/logo-s.png";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "../drawer";
import { useUserState } from "../../../providers/UserProvider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useAuth } from "../../../lib/auth";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function MobileSideBare() {
  const [state, setState] = useState({
    left: false,
    right: false,
  });
  const { t } = useTranslation();
  const [anchor, seAanchor] = useState("left");
  const [anchorEl, setAnchorEl] = React.useState(null);

  useEffect(() => {
    let previusLanguage = localStorage.getItem("language");
    if (previusLanguage && previusLanguage === "fa") {
      seAanchor("right");
    }
  }, []);
  // const [anchor, setAnchor] = useState("left");
  const user = useUserState();
  let auth = useAuth();
  function signOut() {
    auth.signout();
  }
  let fullName = user?.user_login?.fullname;
  let userType = user?.user_login?.approve;

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  const handleClickSettingsButton = (event) => {
    if (Boolean(anchorEl)) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderSettingButtonMenuItems = () => {
    if (user) {
      if (userType === "doctor") {
        return (
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => handleClose}
          >
            <MenuItem>
              <Link to={"/set-calendar"}>
                {t("components.Layout.MobileHeader.setWorkSchedule")}
              </Link>
            </MenuItem>
            <MenuItem>
              <Link to={"/doctor-info"}>
                {t("components.Layout.MobileHeader.specializedMedicalInfo")}
              </Link>
            </MenuItem>
            <MenuItem>
              <Link to={"/profile"}>
                {t("components.Layout.MobileHeader.myInfo")}
              </Link>
            </MenuItem>
            <MenuItem>
              <Link to={"/transactions"}>
                {t("components.Layout.MobileHeader.transaction")}
              </Link>
            </MenuItem>
            <MenuItem>
              <Link to={"/dr-settings"}>
                {t("components.Layout.MobileHeader.settings")}
              </Link>
            </MenuItem>
            <MenuItem onClick={signOut}>
              <Link to={"/login"}>
                {t("components.Layout.MobileHeader.logout")}
              </Link>
            </MenuItem>
          </Menu>
        );
      } else {
        return (
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => handleClose}
          >
            <MenuItem>
              <Link to={"/profile"}>
                {t("components.Layout.MobileHeader.myInfo")}
              </Link>
            </MenuItem>
            <MenuItem>
              <Link to={"/increase-credit"}>
                {t("components.Layout.MobileHeader.increaseCreadit")}
              </Link>
            </MenuItem>
            <MenuItem>
              <Link to={"/withdrawal-request"}>
                {t("components.Layout.MobileHeader.withdrawalRequest")}
              </Link>
            </MenuItem>
            <MenuItem>
              <Link to={"/patient-transactions"}>
                {t("components.Layout.MobileHeader.transaction")}
              </Link>
            </MenuItem>
            <MenuItem>
              <Link to={"/patient-settings"}>
                {t("components.Layout.MobileHeader.settings")}
              </Link>
            </MenuItem>
            <MenuItem onClick={signOut}>
              <Link to={"/login"}>
                {t("components.Layout.MobileHeader.logout")}
              </Link>
            </MenuItem>
          </Menu>
        );
      }
    }
  };

  return (
    <div className={classes.headerContainer}>
      <div>
        <MenuIcon onClick={toggleDrawer(anchor, true)} />
      </div>
      <ButtonComponent
        backgroundColor={COLORS.purple}
        textColor={COLORS.white}
        icon={<SettingsIcon />}
        onClick={handleClickSettingsButton}
      >
        {fullName}

        {renderSettingButtonMenuItems()}
      </ButtonComponent>
      <ButtonComponent
        backgroundColor={COLORS.purple}
        textColor={COLORS.white}
        icon={<HelpIcon />}
        onClick={null}
      >
        Help
      </ButtonComponent>
      <a href="https://sbm24.com/">
        <div>
          <img src={logo} alt="logo alt" />
        </div>
      </a>

      <Drawer
        toggleDrawer={toggleDrawer}
        anchor={anchor}
        drawerStatus={state[anchor]}
      />
    </div>
  );
}

export default MobileSideBare;
